import { LanguageSwitcher } from '@components/shared/LanguageSwitcher';
import { usePageTitle } from '@hooks/usePageTitle';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

export const AuthLayout: React.FC = () => {
	const { t } = useTranslation();

	usePageTitle(t('singUp'));

	return (
		<div className="auth-container h-full bg-main-bg relative">
			<div className="flex items-center justify-end absolute top-[20px] right-0 z-20">
				<LanguageSwitcher />
			</div>
			<main>
				<Outlet />
			</main>
		</div>
	);
};
